import { Component, OnInit, Optional, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { DialogsPerfilService } from './dialogs-perfil.service';
import { LS_LANG } from 'src/app/core/utils/constants';
import { Utils } from 'src/app/core/utils/utils';

@Component({
  selector: 'app-dialogs-perfil',
  templateUrl: './dialogs-perfil.component.html',
  styleUrls: ['./dialogs-perfil.component.scss']
})
export class DialogsPerfilComponent implements OnInit {

  loading: boolean = true;

  constructor(@Optional() @Inject(MAT_DIALOG_DATA) public data: boolean,
              @Optional() private dialogRef: MatDialogRef<DialogsPerfilComponent>,
              private translateService: TranslateService,
              public dialogsPerfilService: DialogsPerfilService) { }

  ngOnInit() {
    this.dialogsPerfilService.init(this.data).subscribe(result => {
      console.log(result);
      this.loading = false;
    });
  }

  /**
  * @description
  * Guardar el Perfil
  */
  guardar() {
    this.loading = true;
    this.dialogsPerfilService.guardar().subscribe(result => {
      console.log(result);
      this.ngOnInit();
      this.loading = false;
    }, error => {
      this.loading = false;
      console.log("Error: " + error);
    });
  }

  /**
  * @description
  * Cierra el dialog perfil y cambio el idioma refrescando
  */
  aceptar() {
    if(this.dialogsPerfilService.userProfile.lang != null){
      this.translateService.setDefaultLang(this.dialogsPerfilService.userProfile.lang);
      this.translateService.use(this.dialogsPerfilService.userProfile.lang);
      localStorage.setItem(LS_LANG, this.dialogsPerfilService.userProfile.lang);
      Utils.changeStyleTranslate();
      this.dialogRef.close(true);
    }
  }

}
